import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../components/Card';
import { Button } from '../components/Button';
import { ArrowLeft, Trophy, TrendingUp, Activity, Target, MapPin, Clock } from 'lucide-react';
import { useStore } from '../data/store';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, LineChart, Line } from 'recharts';
import { KPICard } from '../components/KPICard';
import { toast } from 'sonner';
const trendData = [{
  month: 'Jan',
  score: 82
}, {
  month: 'Feb',
  score: 85
}, {
  month: 'Mar',
  score: 84
}, {
  month: 'Apr',
  score: 88
}, {
  month: 'Mei',
  score: 91
}, {
  month: 'Jun',
  score: 94
}];
export default function KPIDetail() {
  const {
    kode
  } = useParams();
  const navigate = useNavigate();
  const kpiDataList = useStore(s => s.kpi);
  const kpi = kpiDataList.find(k => k.kode === kode);
  if (!kpi) {
    return <div className="flex flex-col items-center justify-center h-full space-y-4" data-id="element-1617">
        <h2 className="text-xl font-mono text-muted-foreground" data-id="element-1618">
          Data KPI tidak ditemukan
        </h2>
        <Button onClick={() => navigate('/kpi')} variant="outline" data-id="element-1619">
          <ArrowLeft className="w-4 h-4 mr-2" data-id="element-1620" /> Kembali ke Dashboard KPI
        </Button>
      </div>;
  }
  return <div className="space-y-6 animate-in fade-in duration-500 max-w-5xl mx-auto" data-id="element-1621">
      <div className="flex items-center gap-4 border-b border-border/50 pb-4" data-id="element-1622">
        <Button variant="ghost" size="icon" onClick={() => navigate('/kpi')} className="hover:bg-primary/20 hover:text-primary" data-id="element-1623">
          <ArrowLeft className="w-5 h-5" data-id="element-1624" />
        </Button>
        <div data-id="element-1625">
          <h1 className="text-2xl font-heading font-bold tracking-tight text-foreground flex items-center gap-3" data-id="element-1626">
            DETAIL KPI WILAYAH
            <span className="text-sm font-mono text-primary bg-primary/10 px-2 py-1 rounded border border-primary/30" data-id="element-1627">
              {kpi.kode}
            </span>
          </h1>
          <p className="text-muted-foreground font-mono text-xs mt-1 uppercase tracking-widest" data-id="element-1628">
            Analisis Kinerja Mendalam
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-1629">
        <div className="md:col-span-2" data-id="element-1630">
          <KPICard title="Wilayah Operasi" value={kpi.name} icon={MapPin} colorVar="var(--primary)" data-id="element-1631" />
        </div>
        <KPICard title="Skor Kinerja" value={`${kpi.score}%`} icon={Activity} colorVar="var(--status-active)" data-id="element-1632" />
        <KPICard title="Rata-rata Respon" value={kpi.responseTime} icon={Clock} colorVar="var(--primary)" data-id="element-1633" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-1634">
        <Card className="glass-panel border-border/50" data-id="element-1635">
          <CardHeader className="border-b border-border/50 bg-card/50" data-id="element-1636">
            <CardTitle className="text-sm font-mono uppercase tracking-widest flex items-center gap-2" data-id="element-1637">
              <Target className="w-4 h-4 text-primary" data-id="element-1638" /> Pencapaian Target
            </CardTitle>
          </CardHeader>
          <CardContent className="p-6 space-y-6" data-id="element-1639">
            <div data-id="element-1640">
              <div className="flex justify-between text-sm mb-2" data-id="element-1641">
                <span className="font-mono text-muted-foreground" data-id="element-1642">
                  Penyelesaian Laporan
                </span>
                <span className="font-mono text-[var(--status-active)]" data-id="element-1643">
                  95%
                </span>
              </div>
              <div className="h-2 bg-black/50 rounded-full overflow-hidden border border-border/50" data-id="element-1644">
                <div className="h-full bg-[var(--status-active)] w-[95%] shadow-[0_0_10px_var(--status-active)]" data-id="element-1645"></div>
              </div>
            </div>
            <div data-id="element-1646">
              <div className="flex justify-between text-sm mb-2" data-id="element-1647">
                <span className="font-mono text-muted-foreground" data-id="element-1648">
                  Kecepatan Respon Insiden
                </span>
                <span className="font-mono text-primary" data-id="element-1649">88%</span>
              </div>
              <div className="h-2 bg-black/50 rounded-full overflow-hidden border border-border/50" data-id="element-1650">
                <div className="h-full bg-primary w-[88%] shadow-[0_0_10px_var(--primary)]" data-id="element-1651"></div>
              </div>
            </div>
            <div data-id="element-1652">
              <div className="flex justify-between text-sm mb-2" data-id="element-1653">
                <span className="font-mono text-muted-foreground" data-id="element-1654">
                  Akurasi Intelijen
                </span>
                <span className="font-mono text-[var(--status-standby)]" data-id="element-1655">
                  92%
                </span>
              </div>
              <div className="h-2 bg-black/50 rounded-full overflow-hidden border border-border/50" data-id="element-1656">
                <div className="h-full bg-[var(--status-standby)] w-[92%] shadow-[0_0_10px_var(--status-standby)]" data-id="element-1657"></div>
              </div>
            </div>

            <div className="pt-4 border-t border-border/50" data-id="element-1658">
              <Button onClick={() => toast.success(`Laporan kinerja ${kpi.name} sedang diunduh (PDF).`)} className="w-full bg-primary/10 text-primary border border-primary/30 hover:bg-primary/20 font-mono text-xs uppercase tracking-widest" data-id="element-1659">
                Unduh Laporan Lengkap
              </Button>
            </div>
          </CardContent>
        </Card>

        <Card className="glass-panel border-border/50" data-id="element-1660">
          <CardHeader className="border-b border-border/50 bg-card/50" data-id="element-1661">
            <CardTitle className="text-sm font-mono uppercase tracking-widest flex items-center gap-2" data-id="element-1662">
              <TrendingUp className="w-4 h-4 text-primary" data-id="element-1663" /> Tren Historis (
              {kpi.name})
            </CardTitle>
          </CardHeader>
          <CardContent className="p-4 h-[300px]" data-id="element-1664">
            <ResponsiveContainer width="100%" height="100%" data-id="element-1665">
              <LineChart data={trendData.map(d => ({
              ...d,
              score: d.score + (kpi.score - 90)
            }))} margin={{
              top: 5,
              right: 30,
              left: 0,
              bottom: 5
            }} data-id="element-1666">
                <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.1)" vertical={false} data-id="element-1667" />
                <XAxis dataKey="month" stroke="rgba(255,255,255,0.5)" tick={{
                fontSize: 10,
                fontFamily: 'monospace'
              }} data-id="element-1668" />
                <YAxis domain={[60, 100]} stroke="rgba(255,255,255,0.5)" tick={{
                fontSize: 10,
                fontFamily: 'monospace'
              }} data-id="element-1669" />
                <Tooltip contentStyle={{
                backgroundColor: 'rgba(15, 18, 25, 0.9)',
                borderColor: 'rgba(255,255,255,0.1)',
                borderRadius: '4px'
              }} itemStyle={{
                color: 'var(--status-active)',
                fontFamily: 'monospace'
              }} data-id="element-1670" />
                <Line type="monotone" dataKey="score" name="Skor" stroke="var(--status-active)" strokeWidth={2} dot={{
                r: 4,
                fill: 'var(--status-active)'
              }} data-id="element-1671" />
              </LineChart>
            </ResponsiveContainer>
          </CardContent>
        </Card>
      </div>
    </div>;
}